import { grey } from "@mui/material/colors";

const styles = {
  button: {
    borderRadius: 1,
  },
  secondary: {
    backgroundColor: "#f0f2ee",
  },
  largePrimary: {
    backgroundColor: "#004537",
    borderRadius: "8px",
    paddingLeft: { xs: "auto", md: "50px" },
    paddingRight: { xs: "auto", md: "50px" },
    py: { xs: 1, md: 1.5 },
    minHeight: "45px",
    color: "white",
    "&:hover": {
      backgroundColor: "primary.dark",
    },
    "&:disabled": {
      backgroundColor: grey[300],
      color: grey[500],
    },
    fontSize: { xs: 14, md: "auto" },
  },
  largeSecondary: {
    backgroundColor: "white",
    borderRadius: "8px",
    paddingLeft: { xs: "auto", md: "50px" },
    paddingRight: { xs: "auto", md: "50px" },
    py: { xs: 1, md: 1.5 },
    minHeight: "45px",
    border: "1px solid #ECEAE5",
    color: "black",
    "&:disabled": {
      backgroundColor: grey[300],
      color: grey[500],
    },
    fontSize: { xs: 14, md: "auto" },
  },
};
export default styles;
